import * as React from "react";
import {isLogin} from "../../modules/auth.ts";
import {Navigate} from "react-router-dom";
import _ from "lodash";

type AuthCheckProps = {
  children: React.ReactNode;
};

/**
 * 로그인 체크
 * @param children
 * @constructor
 */
const AuthCheck: React.FC<AuthCheckProps> = ({ children }) => {
  return isLogin() ? children : <Navigate to="/login" state={{ reloadForce: !_.isEmpty(window.location.search) }} replace />;
};

export default AuthCheck;